import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import RewardCard from "../RewardCard";

const RewardList: FC = () => {
  const {
    state: { rewards },
  } = useRewardCenter();

  return (
    <div data-slot="reward-list" className="flex flex-col gap-1.5">
      {rewards?.map((reward) => (
        <RewardCard key={reward.id} id={reward.id} />
      ))}
    </div>
  );
};

export default RewardList;
